/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-08 17:10:19
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-24 18:02:21
 */

import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const DisinfectionManage: Array<RouteRecordRaw> = [
  {
    path: '/disinfectionManage',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      hidden: true,
     title: 'disinfectionManage',
     icon: 'disinfectionNav',
   },
    children: [
      {
        path: 'Todisbin',
        component: () => import('@/views/disinfectionManage/Todisbin.vue'),
        name: 'Todisbin',
        meta: {
          title: 'Todisbin',
          // icon: 'robotNav',
          noCache: true
        },
      },
      {
        path: 'Accessdevices',
        component: () => import('@/views/disinfectionManage/Accessdevices.vue'),
        name: 'Accessdevices',
        meta: {
          title: 'Accessdevices',
          // icon: 'robotNav',
        }
      },
      {
        path:'equipment/:ids',
        component: ()=> import('@/views/disinfectionManage/Equipment.vue'),
        name:'equipment',
        meta: {
          title: 'equipment',
          noCache: true,
          hidden:true
        }
      },
      {
        path:'disinfectionRecord',
        component: ()=> import('@/views/disinfectionManage/DisinfectionRecord.vue'),
        name:'disinfectionRecord',
        meta: {
          title: 'disinfectionRecord',
          noCache: true,
        }
      },
      {
        path:'warehouseRecord',
        component: ()=> import('@/views/disinfectionManage/WarehouseRecord.vue'),
        name:'warehouseRecord',
        meta: {
          title: 'warehouseRecord',
          noCache: true,
        }
      }
    ]
  },
]

export default DisinfectionManage

